import { walkWidgetConfigTree } from '../../walkWidgetConfigTree';
/**
 * Mutates widget config based on rules.
 * @param config - widget config
 * @param widgets - available widgets
 * @param data - form data
 * @param formParams - form params
 * @param rules - list of rules
 */
export function applyRules(config, widgets, data, formParams, rules) {
    if (rules && rules.length > 0) {
        const ruleMap = {};
        for (const rule of rules) {
            ruleMap[rule.type] = rule;
        }
        walkWidgetConfigTree(config, widgets, (config) => {
            if (config.rules) {
                for (const ruleType of config.rules) {
                    const rule = ruleMap[ruleType];
                    if (rule) {
                        try {
                            rule.applyRule(config, data, formParams);
                        }
                        catch (error) {
                            console.error('Error in event ' + ruleType + ' applyRule function', error);
                        }
                    }
                    else {
                        console.warn('Rule ' + ruleType + ' is not defined');
                    }
                }
            }
        });
    }
}
